export default {
  shareContributionsAmount(value, previousValue, allValues) {
    if (!allValues.shareProgress) {
      return false
    }
    return value
  },
}
